<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">
        <app-i18n code="home.menu" />
      </el-breadcrumb-item>
      <el-breadcrumb-item>
        <app-i18n code="entities.stripePayout.menu" />
      </el-breadcrumb-item>
    </el-breadcrumb>

    <slot name="title"/>
    <div class="app-content-page">
      <h1 class="app-content-title app-content-title--hidden">
        <app-i18n code="entities.stripePayout.list.title" />
      </h1>

      <!-- <app-stripe-payout-list-toolbar /> -->
      <!-- <app-stripe-payout-list-filter /> -->
      <app-stripe-payout-list-table
        :connectedAccountId="connectedAccountId"
        :inscriptionId="inscriptionId"
      />
    </div>
  </div>
</template>

<script>
import StripepayoutListFilter from '@modules/stripe/stripe-payout/components/stripe-payout-list-filter.vue';
import StripepayoutListTable from '@modules/stripe/stripe-payout/components/stripe-payout-list-table.vue';
import StripepayoutListToolbar from '@modules/stripe/stripe-payout/components/stripe-payout-list-toolbar.vue';

export default {
  name: 'app-stripe-payout-list-page',

  props: {
    inscriptionId: {
      type: String,
      default: null,
    },
    connectedAccountId: {
      type: String,
      default: null,
    },
  },
  components: {
    [StripepayoutListFilter.name]: StripepayoutListFilter,
    [StripepayoutListTable.name]: StripepayoutListTable,
    [StripepayoutListToolbar.name]: StripepayoutListToolbar,
  },
};
</script>

<style>
</style>
